export default "/images/gb.svg?1da39e7056a6fde7a5f3a1de24d49a2a";